import { render, staticRenderFns } from "./Destination.vue?vue&type=template&id=030a4875&"
import script from "./Destination.vue?vue&type=script&lang=js&"
export * from "./Destination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports